var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 29.292 7.042 20.5l1.5-1.5 7.291 7.292 15.625-15.625 1.5 1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonCheck);
export default __webpack_public_path__ + "static/media/button-check.fa41cac1bdf1a9fb43e9b96ba062c8ac.svg";
export { ForwardRef as ReactComponent };